import Vue from 'vue'
import Vuex from 'vuex'
import token from './token'
import settings from './settings'
import language from './modules/language'
import feed from './modules/feed'
import article from './modules/article'
import currency from './modules/currency'
import blog from './modules/blog'
import blogCategory from './modules/blogCategory'
import survey from './modules/survey'
import blogTag from './modules/blogTag'
import comment from './modules/comment'
import menuFooter from './modules/menuFooter'
import menuFooterTitle from './modules/menuFooterTitle'
import companyInformation from './modules/companyInformation'
import country from './modules/country'
import menuMain from './modules/menuMain'
import review from './modules/review'
import metaKeyword from './modules/metaKeyword'
import notification from './modules/notification'
import image from './modules/image'
import imageCategory from './modules/imageCategory'
import sticker from './modules/sticker'
import auth from './modules/auth'
import manufacturer from './modules/manufacturer'
import file from './modules/file'
import payment from './modules/payment'
import delivery from './modules/delivery'
import parameter from './modules/parameter'
import address from './modules/address'
import fileCategory from './modules/fileCategory'
import value from './modules/value'
import dashboard from './modules/dashboard'
import group from './modules/group'
import category from './modules/category'
import userAdmin from './modules/userAdmin'
import product from './modules/product'
import order from './modules/order'
import userRegistered from './modules/userRegistered'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    token,
    currency,
    settings,
    auth,
    language,
    feed,
    dashboard,
    survey,
    address,
    parameter,
    value,
    userAdmin,
    review,
    country,
    userRegistered,
    image,
    imageCategory,
    sticker,
    fileCategory,
    file,
    product,
    order,
    group,
    category,
    payment,
    delivery,
    notification,
    article,
    blog,
    manufacturer,
    companyInformation,
    blogCategory,
    blogTag,
    comment,
    menuFooterTitle,
    menuFooter,
    menuMain,
    metaKeyword,
  },
})
